"use client";
import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import type { FC, ReactNode } from 'react';

export const highlightSx: SystemStyleObject<Theme> = {
  '& strong': {
    position: 'relative',
    background: 'color-mix(in srgb, var(--mui-palette-primary-main) 25%, transparent)',
    color: "inherit",
    // color: 'var(--mui-palette-primary-contrastText)',
    padding: '1px 2px',
    ml: '-2px',
    mr: '-2px',
    borderRadius: 1,
  },
};

interface HighlightProps {
  children?: ReactNode;
  component?: any;
  sx?: SystemStyleObject<Theme>;
  dangerouslySetInnerHTML?: { __html: string };
}

const VersuriSearchStyleHighlight: FC<HighlightProps> = ({ children, component = 'span', sx, dangerouslySetInnerHTML, ...rest }) => {
  const mergedSx = { ...(highlightSx), ...(sx) };
  return (
    <Box component={component} sx={mergedSx} dangerouslySetInnerHTML={dangerouslySetInnerHTML} {...rest}>
      {children}
    </Box>
  );
};

export default VersuriSearchStyleHighlight;
